import { stock } from './utils';

export const products = [{
        value: 87.3,
        productName: 'CyberPunk 2077 - PS4',
        stock: stock(1, 200),
    },
    {
        value: 439.99,
        productName: 'Fritadeira Sem Óleo Oster',
        stock: stock(1, 200),
    },
    {
        value: 279.99,
        productName: 'Headset Gamer Havit H2015d',
        stock: stock(1, 200),
    },
    {
        value: 4699.99,
        productName: 'Lenovo Ideapad L340',
        stock: stock(1, 200),
    },
    {
        value: 239.99,
        productName: 'Liquidificador Philips',
        stock: stock(1, 200),
    },
    {
        value: 598.5,
        productName: 'Micro-ondas Consul',
        stock: stock(1, 200),
    },
    {
        value: 1265.25,
        productName: 'Monitor LED 25\'\' Gamer LG',
        stock: stock(1, 200),
    },
    {
        value: 1151.1,
        productName: 'Moto G9 Play',
        stock: stock(1, 200),
    },
    {
        value: 159.6,
        productName: 'Mouse Gamer Redragon Chroma',
        stock: stock(1, 200),
    },
    {
        value: 10377.93,
        productName: 'Smart TV OLED 65\'\' LG',
        stock: stock(1, 200),
    },
    {
        value: 339,
        productName: 'Teclado Gamer HyperX Alloy Core',
        stock: stock(1, 200),
    },
    {
        value: 235.83,
        productName: 'The Last Of Us Part II - PS4',
        stock: stock(1, 200),
    },
    {
        value: 264.48,
        productName: 'SSD 240 gb Plus - Sandisk',
        stock: stock(1, 200),
    },
    {
        value: 3403.08,
        productName: 'Xbox Series S',
        stock: stock(1, 200),
    },
];